import { Navigate } from 'react-router-dom';
import React, { useEffect } from 'react';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = ({ children }) => {
  const { isConnected, loading, checkSession } = useAuth();

  useEffect(() => {
    checkSession(); 
  }, [checkSession]);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!isConnected) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
